export const GRAPHQL_INPUTS = {
  InputUpdateAdditionalOutflow: 'InputUpdateAdditionalOutflow',
  InputCreateAdditionalOutflow: 'InputCreateAdditionalOutflow',
  InputCreatePlato: 'inputPlato_Dto'
} as const
